var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.getAdmin)?_c('app-login'):_vm._e(),_vm._v(" "),(_vm.getAdmin)?_c('div',[_c('app-header'),_vm._v(" "),_c('section',{staticClass:"w-100 d-flex flex-row section-1"},[_c('app-navigation'),_vm._v(" "),_c('section',{staticClass:"d-flex flex-column justify-content-between section-2"},[_c('router-view'),_vm._v(" "),_c('app-footer')],1)],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7be007ed","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 441
// module chunks = 0